import request from '@/utils/request'

export function getExchangeRate() {
  return request({ url: '/dkmall/config/exchange-rate', method: 'get' })
}

export function saveExchangeRate(rate) {
  return request({ url: '/dkmall/config/exchange-rate', method: 'put', data: { rate } })
}
